module.exports = __webpack_public_path__ + "img/joseph-asamoah.8701d816.jpg";